// extracted by mini-css-extract-plugin
module.exports = {"filterItemsWrapper":"HorizontalFilters_filterItemsWrapper__HYFsm","setFormatRight":"HorizontalFilters_setFormatRight__0e74y"};